<div class="join-container">
  @if (isLoading()) {
    <div class="loading">Loading league info...</div>
  } @else if (joinSuccess()) {
    <div class="join-card success">
      <div class="success-icon">&#10003;</div>
      <p class="join-eyebrow">Joined!</p>
      <h2>{{ joinedLeague()?.name }}</h2>
      <p>You are now a member of this league.</p>
      <div class="button-group">
        <a [routerLink]="['/d', joinedLeague()?.hash]" class="db-btn-solid db-btn-solid--full">Go to Draft</a>
        <button class="db-btn-ghost db-btn-ghost--full" (click)="goToDashboard()">Go to Leagues</button>
      </div>
    </div>
  } @else if (error() && !preview()) {
    <div class="join-card error-card">
      <h2>Unable to Load League</h2>
      <p>{{ error() }}</p>
      <a routerLink="/" class="db-btn-ghost db-btn-ghost--full">Back to Home</a>
    </div>
  } @else if (preview(); as p) {
    <div class="join-card">
      <p class="join-eyebrow">Join League</p>
      <h3 class="league-name">{{ p.name }}</h3>

      <div class="league-stats">
        <div class="stat">
          <span class="stat-value">{{ p.spots_available }}</span>
          <span class="stat-label">spots available</span>
        </div>
        <div class="stat">
          <span class="stat-value">{{ p.member_count }}</span>
          <span class="stat-label">of {{ p.max_teams }} members</span>
        </div>
      </div>

      @if (error()) {
        <div class="error-message">{{ error() }}</div>
      }

      @if (p.is_member) {
        <p class="info-message">You're already a member of this league.</p>
        <div class="button-group">
          <a [routerLink]="['/d', hash]" class="db-btn-solid db-btn-solid--full">Go to Draft</a>
          <button class="db-btn-ghost db-btn-ghost--full" (click)="goToDashboard()">Go to Leagues</button>
        </div>
      } @else if (p.is_full) {
        <p class="error-message">This league is full and cannot accept new members.</p>
        <a routerLink="/" class="db-btn-ghost db-btn-ghost--full">Back to Home</a>
      } @else {
        <button
          class="db-btn-solid db-btn-solid--full"
          (click)="join()"
          [disabled]="isJoining()">
          @if (isJoining()) {
            Joining...
          } @else {
            Join League
          }
        </button>
      }
    </div>
  }
</div>
